var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0917969 8.72788C0.0917969 7.76389 0.873264 6.98242 1.83725 6.98242C2.80124 6.98242 3.58271 7.76389 3.58271 8.72788V15.7097C3.58271 16.6737 2.80124 17.4551 1.83725 17.4551C0.873264 17.4551 0.0917969 16.6737 0.0917969 15.7097V8.72788Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32812 1.74546C5.32812 0.781467 6.10959 0 7.07358 0C8.03757 0 8.81903 0.781466 8.81903 1.74545V15.7091C8.81903 16.6731 8.03757 17.4545 7.07358 17.4545C6.10959 17.4545 5.32812 16.6731 5.32812 15.7091V1.74546Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5645 5.23569C10.5645 4.2717 11.3459 3.49023 12.3099 3.49023C13.2739 3.49023 14.0554 4.2717 14.0554 5.23569V15.7084C14.0554 16.6724 13.2739 17.4539 12.3099 17.4539C11.3459 17.4539 10.5645 16.6724 10.5645 15.7084V5.23569Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 5.23569C15.8008 4.2717 16.5822 3.49023 17.5462 3.49023C18.5102 3.49023 19.2917 4.2717 19.2917 5.23569V15.7084C19.2917 16.6724 18.5102 17.4539 17.5462 17.4539C16.5822 17.4539 15.8008 16.6724 15.8008 15.7084V5.23569Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphics);
export default __webpack_public_path__ + "static/media/graphics.7a8bdafb9e2e6a389fc5d4702a0af5fe.svg";
export { ForwardRef as ReactComponent };